$( document ).on( "ajaxComplete", function() {
    $('.component-Configurator-RangeSlider').each(function () {
        var sliderComponent = $(this);
        var rangeInputMin = sliderComponent.find('input.range-slider__input-min');
        var rangeInputMax = sliderComponent.find('input.range-slider__input-max');
        changeHandleZIndices(rangeInputMin, rangeInputMax);
    });
});

$(document).ready(function () {
    $('.component-Configurator-RangeSlider').each(function () {
        var sliderComponent = $(this);
        var rangeInputMin = sliderComponent.find('input.range-slider__input-min');
        var rangeInputMax = sliderComponent.find('input.range-slider__input-max');
        changeHandleZIndices(rangeInputMin, rangeInputMax);
    });

    $(document).on('input.range-slider__input-min change', function (event) {
        var eventSlider = event.target;
        var sliderComponent = $(eventSlider).closest('.component-Configurator-RangeSlider');
        var rangeInputMin = sliderComponent.find('input.range-slider__input-min');
        var rangeInputMax = sliderComponent.find('input.range-slider__input-max');
        var handleMin = sliderComponent.find('.range-slider__handle-min');
        var handleValueMin = sliderComponent.find('.range-slider__handle__value--min');
        var blueBar = sliderComponent.find('.range-slider__blue-bar');
        var sliderStep = parseFloat(rangeInputMin.attr('step'));
        setInputChangeEventListener(rangeInputMin, rangeInputMax, handleValueMin, blueBar, handleMin, sliderStep);
    });

    $(document).on('input.range-slider__input-max change', function (event) {
        var eventSlider = event.target;
        var sliderComponent = $(eventSlider).closest('.component-Configurator-RangeSlider');
        var rangeInputMax = sliderComponent.find('input.range-slider__input-max');
        var rangeInputMin = sliderComponent.find('input.range-slider__input-min');
        var handleMax = sliderComponent.find('.range-slider__handle-max');
        var handleValueMax = sliderComponent.find('.range-slider__handle__value--max');
        var blueBar = sliderComponent.find('.range-slider__blue-bar');
        var sliderStep = parseFloat(rangeInputMax.attr('step'));
        setInputChangeEventListener(rangeInputMax, rangeInputMin, handleValueMax, blueBar, handleMax, sliderStep);
    });

    $(document).on('mousedown touchstart', '.range-slider__input-min', function (event) {
        var eventSlider = event.target;
        var sliderComponent = $(eventSlider).closest('.component-Configurator-RangeSlider');
        var handle = sliderComponent.find('.range-slider__handle-min');
        handle.addClass('range-slider__handle--dragging');
    });

    $(document).on('mousedown touchstart', '.range-slider__input-max', function (event) {
        var eventSlider = event.target;
        var sliderComponent = $(eventSlider).closest('.component-Configurator-RangeSlider');
        var handle = sliderComponent.find('.range-slider__handle-max');
        handle.addClass('range-slider__handle--dragging');
    });

    $(document).on('mouseup touchend', function () {
        $('.range-slider__handle--dragging').removeClass('range-slider__handle--dragging');
    });

    $(document).on('click', '.range-slider__hide-filter-wrapper, .range-slider__label', function (event) {
        var sliderComponent = $(event.target).closest('.component-Configurator-RangeSlider');
        var slidersWrapper = sliderComponent.find('.range-slider__sliders-wrapper');
        slidersWrapper.toggleClass('range-slider__sliders-wrapper--hidden');
        var hideFilterButtonWrapper = sliderComponent.find('.range-slider__hide-filter-wrapper');
        if(hideFilterButtonWrapper){
            hideFilterButtonWrapper.toggleClass('range-slider__hide-filter-wrapper--closed');
        }
    });

    $(document).on('click', '.range-slider__reset-filter-wrapper', function (event) {
        var sliderComponent = $(event.target).closest('.component-Configurator-RangeSlider');
        var rangeInputMax = sliderComponent.find('input.range-slider__input-max');
        var rangeInputMin = sliderComponent.find('input.range-slider__input-min');
        rangeInputMin.val(parseFloat(rangeInputMin.attr('min')));
        rangeInputMax.val(parseFloat(rangeInputMax.attr('max')));
        rangeInputMin.trigger('input').trigger('change');
        rangeInputMax.trigger('input').trigger('change');
    });

});

function setInputChangeEventListener(currRangeInput, secondRangeInput, handleValue, blueBar, handle, sliderStep) {
    var inputType = currRangeInput.hasClass('range-slider__input-min') ? 'min' : 'max';
    var newValue = parseFloat(currRangeInput.val());
    var rangeMaxTotal = parseFloat(currRangeInput.attr('max'));
    var rangeMinTotal = parseFloat(currRangeInput.attr('min'));

    if (inputType == 'min') {
        var rangeInputMinLimit = parseFloat(currRangeInput.data('js-max-limit'));
        if (newValue > rangeInputMinLimit) {
            newValue = rangeInputMinLimit;
        }
        var newRangeInputMaxLimit = ((newValue + sliderStep) == rangeMaxTotal ? rangeMaxTotal : newValue + sliderStep);
        newRangeInputMaxLimit = roundFloatToSliderStepDigits(newRangeInputMaxLimit, sliderStep);
        $(secondRangeInput).data('js-min-limit', newRangeInputMaxLimit).attr('data-js-min-limit', newRangeInputMaxLimit);
        // debug:
        // console.log(
        //     'sliderStep:' + sliderStep,
        //     'rangeInputMinLimit:' + rangeInputMinLimit,
        //     'newRangeInputMaxLimit:' + newRangeInputMaxLimit,
        //     'rangeMaxTotal:' + rangeMaxTotal,
        //     'newValue:' + newValue,
        // );
        changeHandleZIndices(currRangeInput, secondRangeInput);
    } else {
        var rangeInputMaxLimit = parseFloat(currRangeInput.data('js-min-limit'));
        if (newValue < rangeInputMaxLimit) {
            newValue = rangeInputMaxLimit;
        }
        var newRangeInputMinLimit = ((newValue - sliderStep) == rangeMinTotal ? rangeMinTotal : newValue - sliderStep);
        newRangeInputMinLimit = roundFloatToSliderStepDigits(newRangeInputMinLimit, sliderStep);
        $(secondRangeInput).data('js-max-limit', newRangeInputMinLimit).attr('data-js-max-limit', newRangeInputMinLimit);
    }

    currRangeInput.val(newValue);
    var percentage = ((newValue - rangeMinTotal) / (rangeMaxTotal - rangeMinTotal)) * 100;
    updateHandleValue(percentage, handleValue, newValue, handle);
    updateBlueBar(inputType, percentage, blueBar);

}

function roundFloatToSliderStepDigits(value, sliderStep) {
    var decimalPlaces = (sliderStep.toString().split('.')[1] || '').length;
    var multiplier = Math.pow(10, decimalPlaces);
    return Math.round(value * multiplier) / multiplier;
}

function changeHandleZIndices(rangeInputMin, rangeInputMax) {
    var handleMin = rangeInputMin.closest('.range-slider__sliders-wrapper').find('.range-slider__handle-min');
    var handleMax = rangeInputMax.closest('.range-slider__sliders-wrapper').find('.range-slider__handle-max');
    var rangeMinTotal = parseFloat(rangeInputMin.attr('min'));
    var rangeMaxTotal = parseFloat(rangeInputMin.attr('max'));
    var rangeMidValue = (rangeMinTotal + rangeMaxTotal) / 2;
    var rangeInputMinValue = parseFloat(rangeInputMin.val());
    var rangeInputMaxValue = parseFloat(rangeInputMax.val());
    if (rangeInputMinValue > rangeMidValue) {
        rangeInputMin.css('z-index', 10);
        handleMin.css('z-index', 10);
        rangeInputMax.css('z-index', 9);
        handleMax.css('z-index', 9);
    } else if (rangeInputMaxValue < rangeMidValue) {
        rangeInputMin.css('z-index', 9);
        handleMin.css('z-index', 9);
        rangeInputMax.css('z-index', 10);
        handleMax.css('z-index', 10);
    }
}

function updateBlueBar(inputType, percentage, blueBar) {
    if (inputType === 'min') {
        blueBar.css('left', percentage + '%');
    } else {
        blueBar.css('right', (100 - percentage) + '%');
    }
}

function updateHandleValue(percentage, handleValue, newValue, handle) {
    handleValue.text(newValue);
    handle.css('left', percentage + '%');
}

function setInputDraggingListener(rangeInputs, handle) {
    rangeInputs.on('mousedown touchstart', function () {
        handle.addClass('range-slider__handle--dragging');
    });

    $(document).on('mouseup touchend', function () {
        handle.removeClass('range-slider__handle--dragging');
    });
}